import React, {useMemo} from 'react'

import FieldFormElement from "../../../../../../../../../core/fields3/render/form-elemnent"
import ButtonSubmit from "../../../../../../../../../core/gd-form/common/btn-submit/btn-submit-ui5-new"
import FormModel from "../../../../../../../../../core/gd-form/common/form-model-manager"
import FormFieldError from "../../../../../../../../../core/gd-form/common/form-error/form-field-error"
import {ViewTypeConfigs} from "../../../../../../../../../core/gd/const/views/view-type-config"
import AddViewRowTitle from "../row-title/row-title"
import {ViewType} from "../../../../../../../../../core/gd/const/views/view-type"
import {
    projectViews_createProjectViewFromConfig
} from "../../../../../../../../../core/model2/project-view/actions/create"
import {ProjectViewAccess} from "../../../../../../../../../core/model2/project-view/@const"
import ProjectView_Link from "../../../../../../../../../core/model2/project-view/views/link/link-view";
import AddView_SelectView from "./select-view"
import AddView_ViewHeader from "./view-header"


type Props = {
    hidePopover     : func
    onBack          : func
}

const debug = false
// const debug = "AddViewPreviewLinkForm"

export default function AddViewPreviewLinkForm(props: Props) {

    debug && console.log(debug, 'render')

    const onSubmit = async (model: ProjectView_Link) => {
        debug && console.log(debug, 'onSubmit', model, view)

        const params: any = {
            name        : model.name,
            contentUrl  : model.contentUrl,
            access      : model.access,
        }

        debug && console.log(debug, 'onSubmit params', params, view)

        if (view.acl.canDuplicate) {
            gd.projectViews.duplicate(view, params)
        }

        props.hidePopover()
    }

    const view = useMemo(()=>{
        const res = projectViews_createProjectViewFromConfig(gd.projectViews, {
            systemType: ViewType.PROJECT_LINK
        }) as ProjectView_Link

        res.name        = ViewTypeConfigs[ViewType.PROJECT_LINK]!.name
        res.contentUrl  = 'https://'
        res.access      = ProjectViewAccess.PUBLIC
        return res
    }, [])

    const form   = useMemo(()=>new FormModel(view, {
        onSubmit        : onSubmit,
        isFormChanged   : true,
    }), [view])

    // @ts-ignore
    const {iconSvg, description} = ViewTypeConfigs[view.systemType]

    debug && console.log(debug, 'render', view)

    const viewConfig = {
        iconSvg     : iconSvg,
        name        : view.name,
        description : description
    }

    return (
        <div className="flex-column-left-top h-100-percent p-l-10 p-r-10">
            <AddView_SelectView onBack={props.onBack}/>
            <AddView_ViewHeader viewConfig={viewConfig}/>

            {view.acl.canCreateNew &&
                <div className="flex-column-left-top w-100-percent m-t-30">
                    <div className="flex-column-left-top w-100-percent">
                        <AddViewRowTitle field={gd.fields.projectView.name}/>
                        <FieldFormElement className = "w-100-percent"
                                          field     = {gd.fields.projectView.name}
                                          form      = {form}/>
                        <FormFieldError form    = {form}
                                        field   = {gd.fields.projectView.name}/>
                    </div>

                    <div className="flex-column-left-top w-100-percent m-t-15">
                        <AddViewRowTitle field={gd.fields.projectView.access}/>
                        <FieldFormElement className = "w-100-percent"
                                          field     = {gd.fields.projectView.access}
                                          form      = {form}
                                          options   = {{showIcon: true}}/>
                    </div>

                    <div className="flex-column-left-top w-100-percent m-t-15">
                        <AddViewRowTitle field={gd.fields.projectView.contentUrl}/>
                        <FieldFormElement className = "w-100-percent"
                                          field     = {gd.fields.projectView.contentUrl}
                                          form      = {form}/>
                        <FormFieldError className   = "w-100-percent"
                                        form        = {form}
                                        field       = {gd.fields.projectView.contentUrl}/>
                    </div>
                </div>}

            <div className="h-100-percent"/>

            <div className="flex-row-center-center w-100-percent m-b-30">
                <ButtonSubmit size="36" form={form} label="Add view"/>
            </div>
        </div>
    )
}
